import { useDispatch, useSelector } from "react-redux";
import Button from "../../common/Button";
import { useState } from "react";
import { workqueueActions } from "../../../store/workqueue";
import BodySimpleModalV3 from "../../common/modal/BodySimpleModalV3";

export default function RefreshWorkQApi({workQ}) {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)

    const userToken = useSelector(state => state.user.token)
    async function refreshApihandler() {     
        setLoading(true)
        // const systemSettings =  await getSystemSettings(userToken)
        // setStorageItem('settings', systemSettings)

       

        // I don't know why there should be a refresh button if nothing is refreshed?
        // dispatch(filterActions.setCurrentPage(1))
        // dispatch(filterActions.setFiltersMultiple(null))
        // dispatch(filterActions.setExceptionsBatch(null))
        // dispatch(workqueueActions.setInitialLoad(null))
        dispatch(workqueueActions.setRefreshApi())

        setLoading(false)
    }
    return <BodySimpleModalV3 message={'Refresh api'}>
        <Button click={refreshApihandler} isLoading={loading}><i className='ti ti-refresh'></i></Button>
    </BodySimpleModalV3>
}